import React, { useState } from "react";
import _ from "underscore";
import useWeekday from "../hooks/useWeekday";
import { WeeklyDropdown } from "./uiExporter";
import { days } from "../utility/constants";
import { Day } from "../styled_components/styled_weekdays/index";
import blankCheckInHours from "../utility/blankCheckInHours";
import { setHours, setMinutes, setSeconds } from "date-fns";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import moment from "moment/moment";
import { in_array } from "../../../../utils/Helper";

const uuid = _.uniqueId;

// eslint-disable-next-line no-unused-vars
const Weekday = ({ sortdays, toDisable, periodId, checked, anytime, setCheck, check }) => {
  const { byDay, handleAddTime } = useWeekday({ sortdays, periodId });
  for (let i = 0; i < 7; i++) {
    if (byDay[i + 1].length > 0) {
      byDay[i + 1].push({
        ...blankCheckInHours,
        check_in_period_id: periodId.id,
        weekday: i + 1,
      });
    }
  }
  const triggerCheck = (e, k, v) => {
    let newObj = [];
    Object.assign(newObj, check);
    console.log("triggerCheck");
    console.log(newObj);
    if (e.target.checked) {
      newObj.push(v);
    } else {
      newObj.splice(v, 1);
    }
    setCheck(newObj);
    let newTimeObj = {
      weekday: k,
      begin: "00:00",
      end: "23:59",
      check_in_period_id: periodId.id,
    };
    if (e.currentTarget.checked) {
      let start = setHours(setMinutes(setSeconds(new Date(), 0), 0), 0);
      let end = setHours(setMinutes(setSeconds(new Date(), 59), 59), 23);
      handleAddTime(start, end, {
        weekday: k,
        id: null,
        check_in_period_id: periodId.id.toString(),
      });
    } else {
      delete sortdays[k];
    }
  };

  return Object.keys(byDay).map((k, v) => {
    return (
      <div key={uuid()}>
        <Day key={uuid()}>
          {t(days[k].toLowerCase())}
          {/* <input className="margin-left-20" type="checkbox" onChange={e => triggerCheck(e,k,v)} checked={(in_array(v,check))} key={uuid()}/><label>{t('the whole day')}</label>*/}
        </Day>
        {byDay[k].length > 0 &&
          byDay[k].map((v, i) => {
            return (
              <WeeklyDropdown
                key={uuid()}
                hourly={v}
                reference={i > 0 ? byDay[k][i - 1] : null}
                toDisable={toDisable}
                anytime={anytime}
                handleAddTime={handleAddTime}
              />
            );
          })}
        {byDay[k].length < 1 && (
          <WeeklyDropdown
            key={uuid()}
            hourly={{
              ...v,
              weekday: k,
              begin: "",
              end: "",
              check_in_period_id: periodId.id,
            }}
            i={0}
            anytime={anytime}
            min={byDay[v]}
            toDisable={toDisable}
            handleAddTime={handleAddTime}
          />
        )}
      </div>
    );
  });
};

export default Weekday;
